// --- PART 2: HANDLE AJAX VARIANT SWAP WITH THE DEFINITIVE STRATEGY ---
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[swatch-variant-url]');
  // console.log('trigger', trigger);

  if (!trigger) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  document.querySelectorAll('.product-form__submit')
  .forEach(el => {
    el.classList.add('backing_block_cursor');
  });
  const __scrollY = window.scrollY;
  document.body.style.top = `-${__scrollY}px`;
  document.body.style.width = '100%'; 

  const infoWrap = trigger.closest('.product__info-container');
  document.querySelectorAll('.block__product-variants')
  .forEach(el => {
    el.classList.add('backing_wrapper_prod');
  });
  
  // ► Show skeleton placeholders
  ['.block_product-varient--images', 'variant-selects', '.block_post-length-size']
  .forEach(sel => infoWrap?.querySelector(sel)?.classList.add('skeleton'));

  const productUrl = trigger.getAttribute('swatch-variant-url');
  const productInfo = document.querySelector('product-info');
  if (!productInfo || !productUrl) {
    return window.location.href = productUrl;
  }

  const requestUrl = productInfo.buildRequestUrlWithParams(productUrl, [], false);
  const safeTargetId = (trigger.id || '').trim() || null;
  const originalCallback = productInfo.handleSwapProduct(productUrl, false);

  productInfo.renderProductInfo({
    requestUrl,
    targetId: safeTargetId,
    callback: async (html) => {
      originalCallback(html);

      // Re-enable the “Add to cart” button
      document.querySelector('button.product-form__submit')?.removeAttribute('disabled');
      const __y = document.body.style.top;
      document.body.style.top = '';
      window.scrollTo(0, Math.abs(parseInt(__y)) || 0);
    }
  });
});
